import React, { useEffect, useState } from 'react';
import { LoadingDotsWrapper } from './LoadingDots.styles';

const LoadingDots = ({ speed = 500, maxDots = 3, color = 'inherit', size = 'inherit' }) => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prevDots => {
        if (prevDots.length >= maxDots) return '';
        return prevDots + '.';
      });
    }, speed);

    return () => clearInterval(interval);
  }, [speed, maxDots]);

  return (
    <LoadingDotsWrapper color={color} size={size}>
      {dots}
    </LoadingDotsWrapper>
  );
};

export default LoadingDots;
